import apiClient from "~/services/ApiService"
import { getv4LocaleFromI18nLocale } from "~/scripts/useful-functions"
import { type ApiResource, createUrl } from "~/scripts/api-resource"
import type { AxiosInstance } from "axios"
import type { RuntimeConfig } from "#app"

export class ItemService {
  private axios: AxiosInstance
  private config: RuntimeConfig

  constructor(axios: AxiosInstance, config: RuntimeConfig) {
    this.axios = axios
    this.config = config
  }

  async searchItems(query: any, locale: string): Promise<any> {
    const itemSearch = createUrl(this.config.v4Host + "/ng/item-search", query)
    let response

    try {
      response = await this.axios.get(
        itemSearch,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
    } catch (e) {
      console.log("There was an error", e)
    }

    return response
  }

  async getFurnitureDefaultInventory(query: any, locale: string): Promise<any> {
    const furnitureDefaults = createUrl(this.config.v4Host + "/ng/inventory/furniture-defaults", query)
    let response, items

    try {
      response = await this.axios.get(
        furnitureDefaults,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
      if (response && response.data && response.data.items) {
        items = response.data.items
      }
    } catch (e) {
      console.log("There was an error", e)
    }

    return items
  }

  async getCategoryItems(query: any, locale: string): Promise<any> {
    const getItem = createUrl(this.config.v4Host + "/ng/category-items", query)
    let response, items

    try {
      response = await this.axios.get(
        getItem,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
      if (response && response.data && response.data.items) {
        items = response.data.items
      }
    } catch (e) {
      console.log("There was an error", e)
    }

    return items
  }

  async getSearchMakeList(query: any, locale: string): Promise<any> {
    const searchMake = createUrl(this.config.v4Host + "/ng/search/make", query)
    let response, items

    try {
      response = await this.axios.get(
        searchMake,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
      if (response && response.data && response.data.make) {
        items = response.data.make
      }
    } catch (e) {
      console.log("There was an error", e)
    }

    return items
  }

  async getSearchModelList(query: any, locale: string): Promise<any> {
    const searchMake = createUrl(this.config.v4Host + "/ng/search/model", query)
    let response, items

    try {
      response = await this.axios.get(
        searchMake,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
      if (response && response.data && response.data.model) {
        items = response.data.model
      }
    } catch (e) {
      console.log("There was an error", e)
    }

    return items
  }

  async getVehicleData(query: any, locale: string): Promise<any> {
    const getVehicleData = createUrl(this.config.v4Host + "/ng/api/v3/actions/get-vehicle-data", query)
    let response, item

    try {
      response = await this.axios.get(
        getVehicleData,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
      if (response && response.data && response.data.move_items) {
        item = response.data.move_items
        item.quantity = 1
      }
    } catch (e) {
      console.log("There was an error", e)
    }

    return item
  }

  async getItem(query: any, locale: string): Promise<any> {
    const getItem = createUrl(this.config.v4Host + "/ng/get_item", query)
    let response, item

    try {
      response = await this.axios.get(
        getItem,
        {
          headers: {
            "AV-locale": getv4LocaleFromI18nLocale(locale)
          }
        }
      )
      if (response && response.data && response.data.item) {
        item = response.data.item
        item.quantity = 1
      }
    } catch (e) {
      console.log("There was an error", e)
    }

    return item
  }
}
